import { css, SerializedStyles } from '@emotion/react'

/**
 * Applies the passed styles to the direct descendants IFF there are more children than the passed count.
 * Otherwise, the styles are not set at all
 * @param {number} count - The count of descendants required for the styles to be applied
 * @param {CSSInterpolation} childStyles -  The styles to apply to all children elements
 */
export const ifNumChildrenAbove = (count: number, childStyles: SerializedStyles) => {
	const maxChildren = count + 1
	return css`
		& > :nth-last-child(n + ${maxChildren}),
		& > :nth-last-child(n + ${maxChildren}) ~ * {
			${childStyles};
		}
	`
}
